module.exports = __webpack_public_path__ + "static/media/img-8.355a7236.png";